import React from 'react';
import { Box } from '@packages/shared';
import { addPlayerInstance, removePlayerInstance } from './helper';

interface CliplisterVideoProps {
  orderNumber: string;
  customerId: string;
}

export const CliplisterVideo = ({ orderNumber, customerId }: CliplisterVideoProps) => {
  React.useEffect(() => {
    addPlayerInstance(orderNumber, customerId);

    return () => removePlayerInstance();
  }, [orderNumber, customerId]);

  return (
    <Box sx={{ aspectRatio: '16/9' }}>
      <Box id={`cliplister-viewer-${orderNumber}`} />
    </Box>
  );
};
